import React, { useState } from 'react';
import { useConfig } from '../context/ConfigContext';

const Header = ({ pageKey, title, subtitle, subtitleType = 'text', subtitleImage }) => {
    // Función para limpiar siempre la caché de imágenes
    const [cacheBuster] = useState(() => Date.now());
    const getCleanImageUrl = (url) => {
        if (!url) return '';
        return `${url}${url.includes('?') ? '&' : '?'}v=${cacheBuster}`;
    };

    const { config } = useConfig();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    React.useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isAgendaGroup = ['agenda', 'questions_private', 'interactiva', 'register'].includes(pageKey);
    let logoUrl = '';
    if (isMobile) {
        logoUrl = getCleanImageUrl('https://ftp.pcnpublicidad.com/amgen/cel_arriba.png');
    } else {
        logoUrl = isAgendaGroup
            ? getCleanImageUrl('https://ftp.pcnpublicidad.com/amgen/web_arriba_2.png')
            : getCleanImageUrl('https://ftp.pcnpublicidad.com/amgen/web_arriba.png');
    }

    const pageDesign = config?.pageDesigns?.[pageKey] || {};
    const fontColor = pageDesign.globalFontColor || config?.primaryColor || '#f58220';

    return (
        <header className="relative w-full z-50 flex-shrink-0 flex flex-col items-center pointer-events-none">
            <div className="relative w-full flex flex-col items-center">
                {/* Dynamic Logo */}
                {logoUrl && (
                    <div className="w-full flex justify-center">
                        <img
                            src={logoUrl}
                            alt="Logo"
                            className="w-full h-auto object-contain object-top"
                            loading="eager"
                        />
                    </div>
                )}

                {/* Optional Page Title & Subtitle */}
                {(title || subtitle || (subtitleType === 'image' && subtitleImage)) && (
                    <div className="mt-6 text-center animate-fadeInUp">
                        {(title || pageKey === 'agenda') && (
                            <h2
                                className={`font-black uppercase tracking-wider drop-shadow-lg ${pageKey === 'agenda' ? 'text-5xl sm:text-7xl lowercase capitalize' : 'text-2xl sm:text-4xl'}`}
                                style={pageKey === 'agenda' ? {
                                    color: `var(--agenda-font-color, ${fontColor})`,
                                    fontFamily: 'Drina, cursive',
                                    textTransform: 'none'
                                } : {
                                    background: 'linear-gradient(to right, #033f83, #079acf, #65bade)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    backgroundClip: 'text',
                                    color: 'transparent'
                                }}
                            >
                                {pageKey === 'agenda' ? 'Agenda' : title}
                            </h2>
                        )}
                        {subtitleType === 'image' && subtitleImage ? (
                            <div className="mt-3 max-w-[250px] mx-auto">
                                <img
                                    src={subtitleImage}
                                    alt="Subtitle"
                                    className="w-full h-auto object-contain max-h-[80px]"
                                />
                            </div>
                        ) : (
                            (subtitle || pageKey === 'agenda') && (
                                pageKey === 'agenda' ? (
                                    <div className="flex items-center justify-center gap-2 mt-2">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--agenda-font-color, currentColor)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="drop-shadow-sm flex-shrink-0">
                                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                            <circle cx="12" cy="10" r="3"></circle>
                                        </svg>
                                        <p
                                            className="text-2xl sm:text-3xl drop-shadow-sm"
                                            style={{
                                                color: `var(--agenda-font-color, ${fontColor})`,
                                                fontFamily: 'Drina, cursive',
                                                textTransform: 'none'
                                            }}
                                        >
                                            Hotel Intercontinental Cartagena
                                        </p>
                                    </div>
                                ) : (
                                    <div className="inline-block mt-2 px-4 py-1 bg-white/10 backdrop-blur-md rounded-full border border-white/20">
                                        <p
                                            className="text-[10px] sm:text-xs font-bold uppercase tracking-widest"
                                            style={{
                                                background: 'linear-gradient(to right, #033f83, #079acf, #65bade)',
                                                WebkitBackgroundClip: 'text',
                                                WebkitTextFillColor: 'transparent',
                                                backgroundClip: 'text',
                                                color: 'transparent'
                                            }}
                                        >
                                            {subtitle}
                                        </p>
                                    </div>
                                )
                            )
                        )}
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;
